<template lang="pug">
  .p-3
    b-row.align-items-center.h5(v-if="case_object")
      b-col Caso {{ case_object.case_id }}
      b-col(cols="auto")
        CaseStatusBadge(:status="case_object.status")
    b-form-row.align-items-end
      b-col
        CaseActions(one_case, @click="updateCase")
      b-col.mt-2(v-if="$can('read', 'filter-case-messages')")
        b-dropdown(right, size="sm", variant="light", block, :no-caret="filtersCount > 0", :menu-class="['filters-dropdown']")
          template(slot="button-content")
            filter-icon.icon-sm
            span.ml-1(v-if="$breakpoint.mdUp") Filtros
            span.text-sm
              b-badge.ml-1(variant="primary", v-if="filtersCount > 0") {{ filtersCount }}
          b-dropdown-form
            b-form-checkbox(@change="$store.commit('case/filterTypes', {filter: 'event_types', type: 'message_content', value: $event})", :checked="case_events_filters.event_types.includes('message_content')") Mensajes
            b-form-checkbox(@change="$store.commit('case/filterTypes', {filter: 'event_types', type: 'case_message', value: $event})", :checked="case_events_filters.event_types.includes('case_message')") Eventos
          b-dropdown-divider
          b-dropdown-header Filtros de tipo de evento
          b-dropdown-form
            b-form-checkbox(v-for="opt in case_event_options", :key="opt.value", @change="$store.commit('case/filterTypes', {filter: 'event_names', type: opt.value, value: $event})", :checked="case_events_filters.event_names.includes(opt.value)") {{opt.title}}
    hr
    b-tabs(justified)
      b-tab(title="Información")
        .text-sm.text-secondary.mt-3 Etiquetas
        p.text-help(v-if="!caseTags.length") No se ha etiquetado
        .mb-2
          b-badge.mr-1.mb-1.opacity-50(v-for="(tag, index) in caseTags", :key="index", :style="{'background-color': tag.color, color: BWTextColor(tag.color)}") {{ tag.name }}
            x-icon.ml-2.icon-sm.hover-danger.pointer(@click="removeTag(tag.tag_id)")
        .text-sm.text-secondary Agente asignado
        p.text-help(v-if="!caseAdmin") No ha sido asignado
        p(v-else) {{ caseAdmin.first_name }} {{ caseAdmin.last_name }} ({{ caseAdmin.email || '' }})
        .text-sm.text-secondary Grupo
        p {{ caseGroup ? caseGroup.name : 'General' }}
        hr
        div(v-if="userData")
          .text-sm.text-secondary Usuario
          p {{ userName }}
          div(v-if="case_object.platform.indexOf('whatsapp') > -1")
            .text-sm.text-success Whatsapp
            p {{ case_object.User.external_id }}
            div
              .text-sm.text-secondary Tipo de caso
              p {{ case_object.outBound ? 'Outbound' : 'Inbound' }}
          div(v-if="case_object.platform.indexOf('twitter') > -1")
            .text-sm.text-info Twitter
            p.mb-0.text-secondary.d-flex.align-items-center
              span.mr-2 @{{ case_object.User.screen_name }}
              b-img(src="@/assets/verified.png", width="20", height="20", v-if="case_object.User.is_verified")
            b-link(:href="'https://twitter.com/' + case_object.User.screen_name", target="blank") {{ 'https://twitter.com/' + case_object.User.screen_name }}
            b-form-row
              b-col.text-center(md="4", cols="6")
                p.mb-0.font-weight-bold {{ case_object.User.followers || 0 }}
                .text-secondary Seguidores
              b-col.text-center(md="4", cols="6")
                p.mb-0.font-weight-bold {{ case_object.User.friends || 0 }}
                .text-secondary Siguiendo
              b-col.text-center(md="4", cols="6")
                p.mb-0.font-weight-bold {{ case_object.User.tweets || 0 }}
                .text-secondary Tweets
        div(v-if="case_object && case_object.Account")
          .text-sm.text-secondary Cuenta
          p {{ case_object.Account.name }}
            span.ml-2(v-if="account_model") {{ account_model }}
        hr
        UserProperties(v-if="userData.user_id", :user-id="userData.user_id")
      b-tab(title="Avanzado")
        p.mb-0.mt-3 Estatus del bot
        b-form-checkbox.text-secondary(switch, v-model="botEnabled", @change="changed") {{ botEnabled ? 'Bot activo' : 'Bot desactivado' }}
        hr
        p.mb-0 Suscrito a campañas
        b-form-checkbox.text-secondary(switch, v-model="isSubscribed", @change="updateIsSubscribedInUser") {{ isSubscribed ? 'Suscrito' : 'No suscrito' }}
        hr
        p.mb-0 Usuario bloqueado
        b-form-checkbox.text-secondary(switch, v-model="isBanned", @change="updateBannedInUser") {{ isBanned ? 'Sí' : 'No' }}
        hr
        .text-sm.text-secondary Notas
        b-table.scrollable-area.max-h-250(:items="notes", :fields="fields", responsive, show-empty, small, striped, thead-class="d-none")
          template(v-slot:empty)
            .text-center.text-help No hay notas creadas
          template(v-slot:cell(text)="{ item }")
            div(:id="item.case_note_id") {{ item.text.length > 40 ? item.text.slice(0, 40) + '...' : item.text }}
            b-tooltip(:target="`${item.case_note_id}`", triggers="hover",  variant="light")
              p.text-justify.break-space {{ item.text }}
              .text-secondary.text-sm {{ $moment( item.createdAt).format('dddd D MMM YYYY - HH:mmA') }}
        b-form-textarea.mb-1(placeholder="Escribir nueva nota...", v-model.trim="note_text", rows="2", max-rows="4", no-resize, :disabled="note_button_disabled")
        .text-right
          b-button.mt-2(variant="primary", size="sm", @click="createNote", :disabled="!note_text || note_button_disabled" ) Guardar nota
        hr
        b-container.mt-2.mb-2
          b-form-group.d-flex.justify-content-center.align-items-center(label="Descargar chat")
            b-button.mr-2.mt-2(ariant = "downloadConversationStatus ? 'secondary' : 'soft-primary'", @click="downloadConversation('conversation')", :disabled = "downloadConversationStatus") {{ downloadConversationStatus && conversationMode === 'conversation' ? 'Descargando...' : 'Conversación' }}
            b-button.mr-2.mt-2(:variant = "downloadConversationStatus ? 'secondary' : 'soft-primary'", @click="downloadConversation('case')", :disabled = "downloadConversationStatus") {{downloadConversationStatus && conversationMode === 'case' ? 'Descargando...' : 'Caso'}}
            b-button.mt-2(:variant = "downloadConversationStatus ? 'secondary' : 'soft-primary'", @click="downloadNotes()", :disabled = "downloadConversationStatus") {{downloadConversationStatus ? 'Descargando...' : 'Notas'}}
        hr
        user-variables(:platform = "case_object.platform || ''")
</template>

<script>
import CaseActions from './CaseActions.vue'
import CaseStatusBadge from './CaseStatusBadge.vue'
import UserVariables from './UserVariablesList'
import UserProperties from './UserProperties'
import { BWTextColor } from '../helpers/contrast-color-generator'
import _debounce from 'lodash.debounce'
import { createNamespacedHelpers, mapActions } from 'vuex'
import { sendNotification } from '../helpers/notification'
import Download from 'downloadjs'
import mixpanel from '@/mixpanel'
import { EventBus } from '../helpers/eventBus'

const caseController = createNamespacedHelpers('case')

export default {
  data () {
    return {
      conversationMode: null,
      downloadConversationStatus: false,
      note_text: '',
      notes: [],
      action_selected: '',
      fields: ['text'],
      note_button_disabled: false,
      case_event_options: [
        { value: 'derivation', title: 'Derivación' },
        { value: 'assigment', title: 'Asignación' },
        { value: 'status_change', title: 'Cambio de estado' },
        { value: 'tags_change', title: 'Etiquetado' },
      ],
      botEnabled: true,
      isSubscribed: true,
      isBanned: false,
      platform: '',
    }
  },
  inject: {
    caseSocket: { default: Object }
  },
  components: { CaseActions, CaseStatusBadge, UserVariables, UserProperties },
  computed: {
    ...caseController.mapState({
      case_object: state => state.case_object,
      case_events_filters: state => state.case_events_filters
    }),
    caseGroup () {
      return this.case_object ? this.case_object.Group : null
    },
    caseAdmin () {
      return this.case_object ? this.case_object.Admin : null
    },
    userData () {
      return (this.case_object && this.case_object.User) ? this.case_object.User : {}
    },
    userName () {
      return this.userData ? `${this.userData.first_name || ''} ${this.userData.last_name || ''}` : ''
    },
    caseTags () {
      return this.case_object && this.case_object.Tags ? this.case_object.Tags : []
    },
    filtersCount () {
      return this.case_events_filters.event_types.length + this.case_events_filters.event_names.length
    },
    account_model () {
      let {platform_model} = this.case_object
      if(platform_model && platform_model.phone_number) {
        return `(${platform_model.phone_number})`
      }
      return platform_model ? `(Chatbot: ${platform_model.name})` : null
    }
  },
  methods: {
    ...mapActions([
      'case/get',
      'case/notes',
      'case/tags',
      'case/assign',
      'case/derivate',
      'case_note/create',
      'case_note/destroy',
      'account/userAttributesValues',
      'user/update',
      'user/updateBotStatus',
    ]),
    updateBotStatus: _debounce(function () {
      mixpanel.track('Case Info: Update Bot Status', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id,
        bot_enabled: this.botEnabled
      });
      this['user/updateBotStatus']({
        platform: this.platform,
        bot_enabled: this.botEnabled,
        user_id: this.userData.user_id,
        callback: res => {
          this.hideLoadingScreen()

          if (res.error) return this.$message.error(res.error)

          this.$message.success(`Bot ${this.botEnabled ? 'activado' : 'desactivado'}`)
        }
      })
    }, 300),
    changed() {
      this.$nextTick(() => {
        this.updateBotStatus()
      })
    },
    updateIsSubscribedInUser(value) {
      mixpanel.track('Case Info: Update is Subscribed', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id,
        is_subscribed: value
      });
      const self = this
      this.loading = true

      this['user/update']({
        user_id: self.userData.user_id,
        is_subscribed: value,
        callback: res => {
          self.loading = false
          if (res.error) return self.$message.error(res.error)

          self.$message.success('Usuario actualizado')
        }
      })
    },
    updateBannedInUser(value) {
      mixpanel.track('Case Info: Update Banned User', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id,
        is_banned: value
      });
      const self = this
      this.loading = true

      this['user/update']({
        user_id: self.userData.user_id,
        banned: value,
        callback: res => {
          self.loading = false
          if (res.error) return self.$message.error(res.error)

          self.$message.success('Usuario actualizado')
        }
      })
    },
    arrayToCSV(data) {
      let csv = data.map(row => Object.values(row))
      csv.unshift(Object.keys(data[0]))

      return `"${csv.join('"\n"').replace(/,/g, '","')}"`
    },
    downloadNotes() {
      mixpanel.track('Case Info: Download Notes', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });
      this.downloadConversationStatus = true
      this.conversationMode = 'notes'
      const { case_id: caseId } = this.case_object
      const notesInCSV = this.arrayToCSV(this.notes)

      const buffer = new TextEncoder().encode(notesInCSV)

      sendNotification(
        `Notas del caso ${caseId} terminadas`,
        'Tu conversación ha sido descargada',
      )

      this.downloadConversationFile({ buffer })
      this.downloadConversationStatus = false
    },
    downloadConversation(mode) {
      mixpanel.track('Case Info: Download Conversation', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id,
        mode: mode
      });
      const { case_id: caseId } = this.case_object
      this.conversationMode = mode || 'conversation'
      this.downloadConversationStatus = true

      this.caseSocket.emit('downloadConversation', { caseId, mode })

      this.caseSocket.once('downloadConversation', (data) => {
        sendNotification(
          `Reporte del caso ${caseId} terminado`,
          'Tu conversación ha sido descargada',
        )

        this.downloadConversationFile(data)
        this.downloadConversationStatus = false
      })
    },
    downloadConversationFile({ buffer }) {      
      const { case_id: caseId } = this.case_object
      const timeStamp = new Date().getTime()
      const { conversationMode } = this
      const fileName = `${caseId}_chat_${conversationMode}_${timeStamp}.csv`
      const typeOfFile = 'text/csv;charset=utf-8'

      Download(buffer, fileName, typeOfFile)
    },
    getCase() {
      const self = this

      this['case/get']({
        case_id: self.$route.params.case_id,
        params: { account_id: self.$route.params.account_id, },
        soft: true,
        callback: res => {
          if (res.error) return self.$message.error(res.error)

          this.platform = res.resource.platform
          this.botEnabled = res.resource.User ? res.resource.User.bot_enabled : true
          this.isSubscribed = res.resource.User ? res.resource.User.is_subscribed : true
          this.isBanned = res.resource.User ? res.resource.User.banned : false

          this.getUserAttributesValues()
        }
      })
    },
    getNotes() {
      let self = this

      this['case/notes']({
        case_id: self.$route.params.case_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.notes = res.resource
          }
        }
      })
    },
    createNote() {
      if (!this.note_text) return
      mixpanel.track('Case Info: Create Note', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });

      let self = this
      this.note_button_disabled = true

      this['case_note/create']({
        case_id: self.$route.params.case_id,
        text: self.note_text,
        callback: res => {
          this.note_button_disabled = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.note_text = ''
            self.getNotes()
          }
        }
      })
    },
    BWTextColor: BWTextColor,
    getUserAttributesValues () {
      this['account/userAttributesValues']({
        account_id: this.$route.params.account_id,
        user_id: this.case_object.User.user_id,
        params: { platform: this.case_object.platform },
        callback: res => {
          if (res.error) return this.$message.error(res.error)
        }
      })
    },
    removeTag(tag_id) {
      mixpanel.track('Case Info: Remove Tag', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });
      this.$store.commit('case/removeTag', tag_id)
      this.updateCase({ action: 'case/tags', data: { tag_ids: this.case_object.Tags.map(t => t.tag_id) } })
      EventBus.$emit('getSpecificTags')
    },
    updateCase (event) {
      mixpanel.track('Case Info: Update Case', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id,
        status: event.data.status
      });
      let self = this
      self.$store.commit('case/updating')

      this[event.action]({
        case_id: self.$route.params.case_id,
        ...event.data,
        callback: res => {
          if (event.data.read !== undefined) self.$store.commit('case/updating', false)
          if (res.error) {
            self.$message.error(res.error)
          } else {
            if (event.data.status === 'close') {
              this.$message.info('El caso ha sido cerrado')
              if(!this.$can('read', 'stay-in-case')) {
                self.$router.push({name: 'Cases'}).catch(()=>{});
              }
            }
          }
        }
      })
    },
    caseUpdated: _debounce(function (newValue, oldValue) {
      if (newValue) {
        if (!this.$can('read', 'stay-in-case') && (!newValue.admin_assigned_id || newValue.admin_assigned_id != this.getCurrentUser().admin_id)) {
          this.$message.info('El caso ha sido reasignado')
          this.$router.push({name: 'Cases'}).catch(()=>{});
        }
      }
    }, 1000, { trailing: true, leading: false })
  },
  mounted () {
    this.getNotes()
    this.$nextTick(() => { this.getCase() })
  },
  watch: {
    '$route.params.case_id' () {
      this.getCase()
    },
    /*case_object (newValue, oldValue) {
      this.caseUpdated(newValue, oldValue)
    }*/
  },
  beforeDestroy () {
    this.$store.commit('case/updating', false)
  }
}
</script>

<style lang="scss" scoped>
  .scrollable-container-sm {
    overflow-x: auto;
  }
  .ws-normal {
    white-space: normal;
  }

  .max-h-250 {
    max-height: 250px;
  }
</style>
